import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { readPendingExternalAuth, type ExternalProvider } from '@/services/externalAuth';
import ExternalAuthFlow from './components/ExternalAuthFlow';

type NativeReturnState = { flowId: string; handoff: string; provider: ExternalProvider };
export default function ExternalAuthReturnPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { provider: routeProvider } = useParams();
  const provider = (['x', 'telegram', 'apple'].includes(routeProvider || '') ? routeProvider : undefined) as ExternalProvider | undefined;
  const [returned] = useState(() => {
    const state = location.state as NativeReturnState | null;
    const query = new URLSearchParams(location.search);
    const flowId = state?.flowId || query.get('flow_id') || '';
    const handoff = state?.handoff || query.get('handoff') || '';
    if (query.size > 2 || [...query.keys()].some(key => !['flow_id', 'handoff'].includes(key))
      || !/^[a-f0-9]{64}$/.test(flowId) || !/^[A-Za-z0-9_-]{32,128}$/.test(handoff)) return null;
    return { flowId, handoff };
  });
  useEffect(() => { window.history.replaceState({}, '', window.location.pathname); }, []);
  const pending = readPendingExternalAuth();
  if (!provider || !returned) return <main className="p-6"><p role="alert">授权回跳无效，请重新开始。</p><button onClick={() => navigate('/auth')} className="min-h-11 text-indigo-600">返回登录页</button></main>;
  if (pending?.provider === provider && pending.flow_id === returned.flowId) return <ExternalAuthFlow
    provider={provider} intent={pending.intent} flowId={returned.flowId} handoff={returned.handoff}
    onClose={() => navigate(pending.intent === 'login' ? '/auth' : '/security', { replace: true })}
    onSuccess={() => navigate(pending.intent === 'login' ? '/' : '/security', { replace: true })} />;
  const appLink = `forexmind://external-auth/return/${provider}?${new URLSearchParams({
    flow_id: returned.flowId, handoff: returned.handoff,
  }).toString()}`;
  return <main className="mx-auto max-w-sm p-6">
    <h1 className="mb-4 text-xl font-semibold">返回 ForexMind</h1>
    <p className="mb-6 text-sm text-gray-600">如果您在 ForexMind App 中发起授权，请返回原 App 继续验证。此页面不会创建平台会话。</p>
    <a href={appLink} className="block rounded-xl bg-indigo-600 px-5 py-3 text-center text-white">打开 ForexMind App</a>
    <button type="button" onClick={() => navigate('/auth')} className="mt-6 min-h-11 text-indigo-600">在网页重新开始</button>
  </main>;
}
